import PropTypes from 'prop-types';
import React from 'react';

import SocialLinkRowItem from './SocialLinkRowItem';

import style from './SocialLinkRow-style.scss';

const SocialLinkRow = props => {
    const { items } = props;

    return (
        <nav>
            <ul className={style.row}>
                {items.map(item => <SocialLinkRowItem key={item.name} {...item} />)}
            </ul>
        </nav>
    );
};

SocialLinkRow.propTypes = {
    items: PropTypes.array,
};

export default SocialLinkRow;
